
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  --body-font-size:var(--fs-body-sm);
}

.accordion{
  display:flex;
  flex-direction:column;
  row-gap:var(--spacing-6);
}

.accordion--top-content{
  border-bottom:2px solid var(--brand-gray-400);
  padding-bottom:var(--spacing-3);
}
`;